import { useTranslation } from 'react-i18next';

import { GroupedCatalog } from '@/components/events/GroupedCatalog';

/**
 * Categories — `/eventos/categorias`: el catálogo agrupado por categoría.
 * Reemplaza el placeholder estático. Toda la lógica vive en `GroupedCatalog`.
 */
export function Categories(): JSX.Element {
  const { t } = useTranslation('events');
  return (
    <GroupedCatalog
      dimension="category"
      heading={t('grouped.categoriesHeading')}
      subtitle={t('grouped.categoriesSubtitle')}
      fallbackLabel={t('grouped.uncategorized')}
    />
  );
}
